import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoItsFor() {
  const isFor = ['Tienes 50 años o más y sientes que tu energía ha caído en picada.', 'Te despiertas cada noche a la misma hora y no puedes volver a dormir.', "Dependes de suplementos o fármacos para 'noquearte' cada noche.", "Sientes 'niebla mental' y cansancio extremo a las 2 de la tarde."];
  const notFor = ["Buscas una 'pastilla mágica' que solucione todo sin cambiar ningún hábito.", 'Tienes apnea del sueño diagnosticada (eso requiere equipo médico, no un libro).'];
  return <section className="py-16 md:py-24 px-4" data-id="element-218">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-219">
        <FadeIn direction="right" data-id="element-220">
          <div className="bg-navy-800/50 p-8 md:p-10 rounded-3xl border border-green-900/30" data-id="element-221">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-222">
              <CheckCircle2 className="text-green-500 w-8 h-8" data-id="element-223" />
              Este producto es para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-224">
              {isFor.map((item, i) => <li key={i} className="flex items-start gap-4 text-lavender-200" data-id="element-225">
                  <span className="text-green-500 mt-1 flex-shrink-0" data-id="element-226">✓</span>
                  <span data-id="element-227">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn direction="left" delay={0.2} data-id="element-228">
          <div className="bg-navy-800/50 p-8 md:p-10 rounded-3xl border border-red-900/30" data-id="element-229">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-230">
              <XCircle className="text-red-500 w-8 h-8" data-id="element-231" />
              Este producto NO es para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-232">
              {notFor.map((item, i) => <li key={i} className="flex items-start gap-4 text-lavender-200" data-id="element-233">
                  <span className="text-red-500 mt-1 flex-shrink-0" data-id="element-234">✕</span>
                  <span data-id="element-235">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}